import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import TravelButton from 'components/TravelButton';
import ItsYou from './ItsYou';

export default function Welcome({ name, currentAreaName }) {
  return (
    <Fragment>
      <p className="heading heading--3">
        <ItsYou name={name} />
        <br />
        Welcome to
      </p>
      <p className="heading heading--2 welcome__current-area">
        {currentAreaName}
        ,
      </p>
      <p className="heading heading--3">
        delicious friend!
      </p>
      <TravelButton
        className="travel-button--infobar"
      />
    </Fragment>
  );
}

Welcome.propTypes = {
  name: PropTypes.string.isRequired,
  currentAreaName: PropTypes.string.isRequired,
};